<div class="container-xl">
    <div class="row crud-header">
        <div class="col flex-shrink-0 text-nowrap d-flex align-items-center gap-3">
            <div routerLink="/{{Routenames.Projects}}/{{Routenames.Map}}"
                 class="controls-left-button"
                 matTooltip="Terug naar projectenkaart"
                 matTooltipPosition="after">
                <i class="fa fa-arrow-left-from-arc"></i>
            </div>
            <h1 class="mt-2">Tekeningen</h1>
        </div>
        <div class="col justify-content-center d-flex gap-2 pt-3">
            <div>
                <mat-slide-toggle [formControl]="fcErrors" class="text-nowrap pt-3">
                    Alleen errors
                </mat-slide-toggle>
            </div>
            <ng-select class="drawings-filter project-dropdown ng-select-fill"
                       [items]="projects"
                       bindLabel="name"
                       bindValue="id"
                       placeholder="Project"
                       [clearable]="true"
                       [formControl]="projectIdControl">
                <ng-template ng-label-tmp let-item="item">
                    {{ item.id_4ps ? item.id_4ps + ' - ' : '' }}{{ item.name }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                    {{ item.id_4ps ? item.id_4ps + ' - ' : '' }}{{ item.name }}
                </ng-template>
            </ng-select>
            <ng-select class="drawings-filter ng-select-fill"
                       [items]="drawers"
                       bindLabel="name"
                       bindValue="initials"
                       placeholder="Tekenaar"
                       [clearable]="true"
                       [searchFn]="drawerSearchFn"
                       [formControl]="drawerInitialsControl">
                <ng-template ng-label-tmp let-item="item">
                    {{ item.name ? (item.initials | lowercase) + ' - ' + item.name : (item.initials | lowercase) }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                    {{ item.name ? (item.initials | lowercase) + ' - ' + item.name : (item.initials | lowercase) }}
                </ng-template>
            </ng-select>
            <mat-form-field>
                <input matInput #searchInput class="searchInput" [(ngModel)]="searchString" placeholder="Zoeken" type="text"/>
            </mat-form-field>

        </div>
    </div>
    <div class="row mb-2 justify-content-end">
        <div class="col-auto">
            <mat-paginator [pageSizeOptions]="[100, 10, 500]"></mat-paginator>
        </div>
    </div>
    <table [dataSource]="dataSource" class="mat-elevation-z8 w-100 mb-4" mat-table matSort matSortActive="updated_at" matSortDirection="desc">
        <ng-container matColumnDef="updated_at">
            <th *matHeaderCellDef mat-header-cell mat-sort-header width="150">Aangepast</th>
            <td *matCellDef="let drawing" class="text-right pr-3" mat-cell> {{ drawing.updated_at | date: 'd MMM yyyy HH:mm' }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
            <th *matHeaderCellDef mat-header-cell mat-sort-header width="120">Datum</th>
            <td *matCellDef="let drawing" class="text-right pr-3" mat-cell> {{ drawing.date | date: 'd MMM yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="filename">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Naam</th>
            <td *matCellDef="let drawing" mat-cell [matTooltip]="drawing.name">
                <span>{{ (drawing.name | drawingName).substring(0, 30) }}</span><br>
                @if (drawing.error) {
                    <small class="error">{{ drawing.error }}</small>
                }
                <a routerLink="/{{Routenames.Drawings}}"
                   class="my-2"
                   [queryParams]="{search: drawing.id}">
                    {{ drawing.filename }}&nbsp;&nbsp;({{ drawing.revision }})<span class="dot">&nbsp;&nbsp;&middot;&nbsp;&nbsp;</span>#{{ drawing.id }}
                </a>
            </td>
        </ng-container>
        <ng-container matColumnDef="drawer">
            <th *matHeaderCellDef mat-header-cell>Tekenaar</th>
            <td *matCellDef="let drawing" mat-cell>
                {{ drawing.drawer?.name || drawing.drawer_initials || '-' }}
            </td>
        </ng-container>
        <ng-container matColumnDef="project_id">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Kaart</th>
            <td *matCellDef="let drawing" mat-cell>
                <a color="primary" mat-flat-button
                   routerLink="/{{Routenames.Projects}}/{{drawing.project_id}}"
                   [queryParams]="{drawing: drawing.id}"
                   matTooltip="Open project / kaart">
                    <i class="fa fa-map"></i>
                </a>
            </td>
        </ng-container>
        <ng-container matColumnDef="dwgToJson">
            <th *matHeaderCellDef mat-header-cell>{{ (Roles.Codalt | hasRole) ? 'DWG => JSON' : 'Conversie' }}</th>
            <td *matCellDef="let drawing" class="text-right" mat-cell>
                <button (click)="dwgToJson(drawing, false, true)"
                        (contextmenu)="openDwgToJsonContextMenu($event, drawing)"
                        [disabled]="drawing['extracting']"
                        color="primary"
                        mat-flat-button
                        matTooltip="Tekening converteren">
                    @if (drawing.json_data_length > 0) {
                        <i class="fa-solid fa-check me-2"></i> {{ drawing?.json_data_length }}
                    } @else {
                        <i class="fa fa-spinner fa-spin" *ngIf="drawing['extracting']"></i>
                        <i class="fa-solid fa-play" *ngIf="!drawing['extracting']"></i>
                    }
                </button>
                <small>{{ drawing.extracted_at | codaltDate: 'd MMM YYYY H:mm' }}</small>
            </td>
        </ng-container>
        <ng-container matColumnDef="dxfToSvg">
            <th *matHeaderCellDef mat-header-cell>SVG gen</th>
            <td *matCellDef="let drawing" class="text-right" mat-cell>
                <button (click)="generateSvgs(drawing)"
                        (contextmenu)="openSvgContextMenu($event, drawing)"
                        [disabled]="drawing['generatingSvgs']==drawing.id || !drawing.retrieved_at || drawing.entities_count === 0"
                        color="primary"
                        mat-flat-button
                        matTooltip="Genereer SVGs">
                    @if (drawing['entity_images_count'] > 0) {
                        <i class="fa fa-check"></i> {{ drawing['entity_images_count'] }}
                    } @else {
                        <i class="fa fa-spinner fa-spin" *ngIf="drawing['generatingSvgs']"></i>
                        <i class="fa fa-file-svg" *ngIf="!drawing['generatingSvgs']"></i>
                    }
                </button>
                <small>{{ drawing.svg_generated_at | codaltDate: 'd MMM YYYY H:mm' }}</small>
            </td>
        </ng-container>
        <ng-container matColumnDef="convert">
            <th *matHeaderCellDef mat-header-cell>Conversie</th>
            <td *matCellDef="let drawing" class="text-right" mat-cell>
                <button (click)="convert(drawing)"
                        (contextmenu)="openConvertContextMenu($event, drawing)"
                        color="primary"
                        [disabled]="drawing['converting'] || !drawing.retrieved_at || drawing.json_data_length === 0"
                        mat-flat-button
                        class="me-2"
                        matTooltip="Conversie uitvoeren">
                    @if (drawing['entities_count'] > 0) {
                        <i class="fa fa-check"></i> {{ drawing['entities_count'] }}
                    } @else {
                        <i class="fa fa-spinner fa-spin" *ngIf="drawing['converting']"></i>
                        <i class="fa fa-route" *ngIf="!drawing['converting']"></i>
                    }
                </button>
                <small>{{ drawing.converted_at | codaltDate: 'd MMM YYYY H:mm' }}</small>
            </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>
    <div class="row pb-3 justify-content-end">
        <div class="col-auto">
            <mat-paginator [pageSizeOptions]="[100, 10, 500]"></mat-paginator>
        </div>
    </div>
    <span style="position: fixed; visibility: hidden; pointer-events: none;"
          [style.left.px]="contextMenuPosition.x"
          [style.top.px]="contextMenuPosition.y"
          [matMenuTriggerFor]="svgContextMenu"
          #svgMenuTrigger="matMenuTrigger">
    </span>
    <mat-menu #svgContextMenu="matMenu">
        <button mat-menu-item (click)="generateSvgs(contextMenuDrawing)">
            <i class="fa fa-layer-group me-2"></i>Converteren op queue
        </button>
        <button mat-menu-item (click)="generateSvgs(contextMenuDrawing, false)">
            <i class="fa fa-bolt me-2"></i>Direct
        </button>
    </mat-menu>
    <span style="position: fixed; visibility: hidden; pointer-events: none;"
          [style.left.px]="contextMenuPosition.x"
          [style.top.px]="contextMenuPosition.y"
          [matMenuTriggerFor]="convertContextMenu"
          #convertMenuTrigger="matMenuTrigger">
    </span>
    <mat-menu #convertContextMenu="matMenu">
        <button mat-menu-item (click)="convert(contextMenuConvertDrawing)">
            <i class="fa fa-layer-group me-2"></i>Converteren (alleen tekening) op queue
        </button>
        <button mat-menu-item (click)="convert(contextMenuConvertDrawing, false)">
            <i class="fa fa-bolt me-2"></i>Direct converteren (alleen tekening)
        </button>
        <a mat-menu-item routerLink="/convert/{{contextMenuConvertDrawing?.id}}">
            <i class="fa fa-route me-2"></i>Open converter
        </a>
    </mat-menu>
    <span style="position: fixed; visibility: hidden; pointer-events: none;"
          [style.left.px]="contextMenuPosition.x"
          [style.top.px]="contextMenuPosition.y"
          [matMenuTriggerFor]="dwgToJsonContextMenu"
          #dwgToJsonMenuTrigger="matMenuTrigger">
    </span>
    <mat-menu #dwgToJsonContextMenu="matMenu">
        <button mat-menu-item (click)="dwgToJson(contextMenuDwgDrawing, false, true)">
            <i class="fa fa-play me-2"></i>Direct converteren
        </button>
        <button mat-menu-item (click)="dwgToJson(contextMenuDwgDrawing)">
            <i class="fa fa-layer-group me-2"></i>DWG naar JSON op de queue
        </button>
        <button mat-menu-item (click)="dwgToJson(contextMenuDwgDrawing, false, false)">
            <i class="fa fa-bolt me-2"></i>DWG naar JSON direct
        </button>
    </mat-menu>
</div>
